import React from 'react';
import { Container } from 'reactstrap';
import { DashboardPageHeader } from "../../../../Components/Common/DashboardKit";
import BasicAction from "./BasicAction";
import SubscribeAction from "./SubscribeAction";
import EmailVerifyAction from "./EmailVerifyAction";
import PasswordChangeAction from "./PasswordChangeAction";

const index = () => {
    document.title = "Basic Action | Velzon - React Admin & Dashboard Template";
    
    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <DashboardPageHeader
                        icon="ri-mail-line"
                        title="Basic Action"
                        subtitle="Reusable transactional email templates"
                        tone="blue"
                        breadcrumb={[
                            { label: "Email" },
                            { label: "Basic Action" },
                        ]}
                    />
                    <BasicAction />
                    <SubscribeAction />
                    <EmailVerifyAction />
                    <PasswordChangeAction />
                </Container>
            </div>
        </React.Fragment>
    );
}

export default index;